import React from 'react';
import {Component, ReactNode} from 'react';
import {Dropdown, DropdownProps} from '@priority-software/priority-style-react';
import {SearchInputProps} from './SearchInput';
import DropdownSearchInput from './DropdownSearchInput';
import {createDataTestId} from '../../../../utils/dataTestId';

export interface DropdownSearchProps extends Partial<DropdownProps> {
    /** options are displayed when search input gets focused, before start typing. default: false */
    openOnFocus?: boolean;
    inputProps: SearchInputProps;
    // trigger injected props
    triggerRef?: React.RefObject<any>;

    onTriggerFocus?(event?): void;

    onTriggerBlur?(event?): void;

    closeOnClear?: boolean;
    clearOnClose?: boolean;
    componentClasses?: string[] | string;
    withArrowIcon?: boolean;
    withTriggerWrapper?: boolean;
    children?: ReactNode;
    withDataTestId?: boolean;
}

export class SearchDropdown extends Component<DropdownSearchProps, null> {
    onDropdownClose = e => {
        // clear input value when dropdown closes
        const {onClose, inputProps, clearOnClose = true} = this.props;
        onClose && onClose(e);
        if (clearOnClose) {
            inputProps?.onReset ? inputProps.onReset() : inputProps?.onChange?.('');
        }
    };

    render() {
        const {
            openOnFocus,
            inputProps,
            closeOnClear,
            withArrowIcon,
            withTriggerWrapper,
            triggerRef,
            withDataTestId
        } = this.props;

        return (
            <Dropdown
                //To DO : add to style lib this props
                {...createDataTestId('search-dropdown', true)}
                {...this.props}
                width="fullWidth"
                focusOnOpen
                onClose={this.onDropdownClose}
                trigger={
                    <DropdownSearchInput
                        openOnFocus={openOnFocus}
                        triggerRef={triggerRef}
                        closeOnClear={closeOnClear}
                        withArrowIcon={withArrowIcon}
                        withTriggerWrapper={withTriggerWrapper}
                        withDataTestId={withDataTestId}
                        inputProps={{
                            returnFocus: inputProps.value !== '',
                            ...inputProps
                        }}
                    />
                }
            >
                {this.props.children}
            </Dropdown>
        );
    }
}
